import { CVFile } from "../interface/CV_types";
import { CVFileContainer } from "./CVFileContainer";
import { BottomButtons } from "./BottomButtons";


export function CVListContainer({ files, project_id }: { files: CVFile[]; project_id: string; }) {
    return (
        <div className="flex flex-col gap-4 p-4 border border-cv-file-border rounded-md">
            {/* This shows the list of files in the folder */}

            {files.length === 0 && <p className="text-center text-gray-500">No files in this folder</p>}

            {files.map((file) => (
                <CVFileContainer key={file.name} file={file} project_id={project_id} />
            ))}

            <BottomButtons project_id={project_id} />
        </div>
    );
}
